import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterHorizontal12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconGutterHorizontal12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 10.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.501-.5.5.5 0 0 1 0-1A1.5 1.5 0 0 1 3 2.5v7A1.5 1.5 0 0 1 1.5 11a.5.5 0 0 1-.5-.5m10-9a.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5.5.5 0 1 1 0 1A1.5 1.5 0 0 1 9 9.5v-7A1.5 1.5 0 0 1 10.5 1a.5.5 0 0 1 .5.5M5.5 9a.5.5 0 0 0 1 0V3a.5.5 0 1 0-1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterHorizontal12);
